module.exports = __webpack_public_path__ + "img/popup.bb0ca1ae.png";